import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFormattedOnboardingProgressData } from '../utils/onboardingProgressApis';
export const initialState = {
  isFetchingOnboardingProgress: false,
  hasError: false,
  progress: 0,
  selectedView: '',
  groupKey: undefined
};
export const fetchOnboardingProgress = createAsyncThunk('onboardingProgress/fetchOnboardingProgress', portalId => getFormattedOnboardingProgressData(portalId));
export const onboardingProgressSlice = createSlice({
  name: 'onboardingProgress',
  initialState,
  reducers: {
    setOnboardingProgress: (state, action) => {
      state.progress = action.payload.progress;
      state.selectedView = action.payload.selectedView;
      state.groupKey = action.payload.groupKey;
    }
  },
  extraReducers(builder) {
    builder.addCase(fetchOnboardingProgress.pending, state => {
      state.isFetchingOnboardingProgress = true;
    }).addCase(fetchOnboardingProgress.fulfilled, (state, action) => {
      state.isFetchingOnboardingProgress = false;
      state.progress = action.payload.progress;
      state.selectedView = action.payload.selectedView;
      state.groupKey = action.payload.groupKey;
    }).addCase(fetchOnboardingProgress.rejected, state => {
      state.isFetchingOnboardingProgress = false;
      state.hasError = true;
    });
  }
});
export const {
  setOnboardingProgress
} = onboardingProgressSlice.actions;
export default onboardingProgressSlice.reducer;